import { css, cx } from "emotion";
import Modal from "react-modal";
import React, { Component } from "react";
import theme from "components/theme";

class Lightbox extends Component {
  render() {
    const { closeButton = true, onClose, title, contentClass } = this.props;
    const isOpen = this.props.isOpen;

    return (
      <Modal isOpen={isOpen} onRequestClose={onClose} className={this.styles.root}>
        <div className={cx("content", contentClass)}>
          {closeButton && (
            <div className={"lbButton"} onClick={onClose}>
              X
            </div>
          )}

          {title && <h3>{title}</h3>}

          {this.props.children}
        </div>
      </Modal>
    );
  }

  styles = {
    root: css`
      .content {
        font-size: 1.2em;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid #000;
        padding: 2em;
        background: #fff;

        ${theme.media.xsMax} {
          width: 80%;
        }
      }

      h3 {
        text-align: center;
        margin-top: 0;
        margin-bottom: 1em;
      }

      .lbButton {
        position: absolute;
        right: 12px;
        cursor: pointer;
        top: 12px;
        font-size: var(--h3-font-size);
      }

      @media (min-width: 768px) {
        .simpleDark.wrapper {
          padding: 0px;
        }
      }
    `,
  };
}

export default Lightbox;
